import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

function useDeepCompareMemoize<T>(value: T) {
  const ref = useRef<T>(value);

  if (!isEqual(value, ref.current)) {
    ref.current = cloneDeep(value);
  }

  return ref.current;
}

export function useDeepCompareEffect(callback: EffectCallback, dependencies: DependencyList): void {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(callback, useDeepCompareMemoize(dependencies));
}
